export enum CmsPageContentIdentifier {
  Compendium = 'Compendium',
  Title = 'Title',
  HighlightText = 'HighlightText',
  ActivationFeeText = 'ActivationFeeText',
  BuyHardwareTeaser = 'BuyHardwareTeaser',
}

export enum CmsRouterContentIdentifier {
  CombiRouterHeaderText = 'CombiRouterHeaderText',
  CombiRouterHighlightText = 'CombiRouterHighlightText',
  RouterAndOntHeaderText = 'RouterAndOntHeaderText',
  GeneralRouterHeaderText = 'GeneralRouterHeaderText',
  OwnRouterHeaderText = 'OwnRouterHeaderText',
  RouterClassInfo = 'RouterClassInfo',
  OntClassInfo = 'OntClassInfo',
  CombiRouterClassInfo = 'CombiRouterClassInfo',
  OwnRouterLearnMore = 'OwnRouterLearnMore',
  RouterPriceInfo='RouterPriceInfo',
  OwnRouterInfoHeaderTextDsl = 'OwnRouterInfoHeaderTextDsl',
  OwnRouterInfoHeaderTextFms = 'OwnRouterInfoHeaderTextFms',
  OwnRouterInfoHeaderTextCable = 'OwnRouterInfoHeaderTextCable',
  OwnRouterInfoHeaderTextFtth = 'OwnRouterInfoHeaderTextFtth',
  OwnRouterDescriptionTextDsl = 'OwnRouterDescriptionTextDsl',
  OwnRouterDescriptionTextFms = 'OwnRouterDescriptionTextFms',
  OwnRouterDescriptionTextCable = 'OwnRouterDescriptionTextCable',
  OwnRouterDescriptionTextFtth = 'OwnRouterDescriptionTextFtth'
}

export type CmsPageContentType = {
  [key: string]: any
};

export enum TargetGroup {
  PRIVATKUNDEN = 'PRIVATKUNDEN',
  STUDENTEN = 'STUDENTEN',
  SELBSTAENDIGE = 'SELBSTAENDIGE',
  BESTANDSKUNDEN = 'BESTANDSKUNDEN',
}

export enum HardwareClass {
  O = 'O',
  R = 'R',
  OR = 'OR',
}

export interface ReduxStateType {
  cmsContent: CmsPageContentType
  hardwareOptions: HardwareOptionType[]
  hardwareSelectionHint: string
  hardwareSelectionEnabled: boolean
  accessType: string
}

export interface ActionType {
  type: string
  value: any
}

export interface ChargesType {
    recurringCosts: number
    activationFee: number
    shippingCosts: number
    nonRecurringCosts: number
    nextPriceCharges: NextPriceChargesType[]
}
export interface NextPriceChargesType {
    recurringCosts: number,
    startingMonth: number,
}

export interface SelectedHardwareType {
  tariffOfferName: string
  shopContext: string
  articleId: string
  selected: boolean
  ownHardware: boolean
}

interface HardwareBaseType {
  ownHardware: boolean
  selected: boolean
  cmsContent: CmsHardwareDescriptionType
}

export interface OwnHardwareType extends HardwareBaseType {
  articleId?: string
  articleName?: string
  contentId?: string
  hardwareClass?: never
  charges?: never
}

export interface ExternalHardwareType extends HardwareBaseType {
  articleId: string
  articleName: string
  contentId: string
  hardwareClass: string
  charges: ChargesType
}

export interface CmsHardwareDescriptionType {
  name: CmsHardwareContentType
  description: CmsHardwareContentType
  imageUrl: CmsHardwareContentType
  hint?: CmsHardwareContentType
  detailDescription?: CmsHardwareContentType
}

export interface CmsDebugInfoType {
  url: string,
}

export interface CmsHardwareContentType {
  content: string,
  debugInfo?: CmsDebugInfoType,
  rendered: string,
}

export type HardwareOptionType = OwnHardwareType | ExternalHardwareType;

export interface GetHardwareResponseType {
  hardware: HardwareOptionType[]
  hardwareSelectionHint: CmsHardwareContentType
  hardwareSelectionEnabled: boolean
  accessType: string
}

export interface HardwareRentPageValueType {
  cmsContent: CmsPageContentType,
}
